import { RENTAL_TYPES } from '@/utils/constants'

const rentalTypes = {
  props: {
    rentalPeriod: {
      type: [String, Array],
    },
  },

  data () {
    return {
      values: [],
      options: [],
    }
  },

  created () {
    const period = this.rentalPeriod

    if (Array.isArray(period)) {
      this.values = [...period]
    }
  },

  mounted () {
    this.options = RENTAL_TYPES
  },

  methods: {
    $_rental_types_on_change () {
      this.$emit('filters:update', {
        rentalPeriod: this.values,
      })
    },
  },
}

export default rentalTypes
